import type { NotificationService } from '@repo/core';

/**
 * Web Notification API implementation.
 *
 * For Capacitor mobile, replace with @capacitor/local-notifications:
 * ```ts
 * import { LocalNotifications } from '@capacitor/local-notifications';
 * ```
 */
export class WebNotificationService implements NotificationService {
  async requestPermission(): Promise<boolean> {
    if (!('Notification' in window)) return false;
    if (Notification.permission === 'granted') return true;
    const result = await Notification.requestPermission();
    return result === 'granted';
  }

  async show(title: string, body: string): Promise<void> {
    const granted = await this.requestPermission();
    if (!granted) return;
    new Notification(title, { body });
  }
}
